import { Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

export const Navigation = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // cuando se monta Home, si hay un hash guardado -> scroll
  useEffect(() => {
    if (pathname === "/" && sessionStorage.getItem("scrollTo")) {
      const hash = sessionStorage.getItem("scrollTo");
      sessionStorage.removeItem("scrollTo");
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [pathname]);

  const goTo = (hash) => (e) => {
    e.preventDefault();
    if (pathname !== "/") {
      sessionStorage.setItem("scrollTo", hash);
      navigate("/"); // primero vamos a /
    } else {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          {/* Logo alineado a la izquierda */}
          <Link to="/" className="navbar-brand page-scroll">
            <img src="/img/logo.png" alt="Hípica Madrid Campogrande" />
          </Link>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" onClick={goTo("#features")}>
                Ventajas
              </a>
            </li>
            <li>
              <a href="#about" onClick={goTo("#about")}>
                Sobre nosotros
              </a>
            </li>
            <li>
              <a href="#services" onClick={goTo("#services")}>
                Servicios
              </a>
            </li>
            <li>
              <Link to="/escuela-hipica#tarifas">Tarifas</Link>
            </li>
            <li>
              <a href="#portfolio" onClick={goTo("#portfolio")}>
                Galería
              </a>
            </li>
            <li>
              <a href="#testimonials" onClick={goTo("#testimonials")}>
                Testimonios
              </a>
            </li>
            <li>
              <a href="#team" onClick={goTo("#team")}>
                Equipo
              </a>
            </li>
            <li>
              <a href="#contact" onClick={goTo("#contact")}>
                Contacto
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
